export default __webpack_public_path__ + "static/media/sticker-promo-co.06cff941.webp";